// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3x3Ne","label":"SetPasswdForm_label__1vQLK"};